/**
 * Created by ferasmasood on 8/15/17.
 */

'use strict';
angular.module('harriApp')
    .controller('GlobalSearchResultController', ['$scope', 'hUser', '$stateParams', '$state', '$filter', 'deviceChecker', function ($scope, hUser, $stateParams, $filter, deviceChecker) {

        var user = hUser.data.user;
        $scope.results = [];
        $scope.hitsCallback = {};
        var counter = 0;
        $scope.searchPhrase = $stateParams.search_phrase || "";
        $scope.searchPhrase = $scope.searchPhrase.trim();
        $scope.resultsLimit = GlobalSearchAPI.RECORDS_LIMIT;
        $scope.type = '';
        var requestId;

        var getResults = function (type) {
            var currentRequestId = Date.now();
            requestId = currentRequestId;
            var searchTypes;
            $scope.type = type;
            if (type) {
                if (type === "EMPLOYEE") {
                    searchTypes = ['TEAM_LIVE_EMPLOYEE', 'ONBOARDING_EMPLOYEE'];
                } else {
                    searchTypes = [type];
                }
            }

            if (!$scope.results || $scope.results.length == 0) {
                $scope.loading = true;
            }

            GlobalSearchDataManager.getSearchResult(hUser, $scope.searchPhrase, counter++ * GlobalSearchAPI.RECORDS_LIMIT, GlobalSearchAPI.RECORDS_LIMIT, searchTypes).then(function (res) {
                if(currentRequestId === requestId) {
                    delete $scope.loading;
                    $scope.results = $scope.results.concat(res.results);
                    $scope.hits = res.hits;
                    $scope.resultsLimit = $scope.hits;
                    $scope.hitsCallback.setHits($scope.hits);
                    if ((counter - 1) * GlobalSearchAPI.RECORDS_LIMIT <= $scope.hits) {
                        GlobalSearchDataManager.getSearchResult(hUser, $scope.searchPhrase, counter++ * GlobalSearchAPI.RECORDS_LIMIT, GlobalSearchAPI.RECORDS_LIMIT, searchTypes).then(function (res) {
                            $scope.results = $scope.results.concat(res.results);
                            $scope.hits = res.hits;
                            $scope.resultsLimit = $scope.hits;
                            $scope.$digest()
                        });
                    }
                    $scope.$digest();
                }
            })

        };

        $(document).ready(function () {
            var latestTop = 0;
            var requestLock = false;
            $(".container-fluid.search-page").on('scroll', function (event) {
                var currentTop = $(".global-search-wrapper.result-page").offset().top;

                if ($scope.results.length >= $scope.resultsLimit) {
                    return;
                }

                if ((($(".container-fluid.search-page").scrollTop() % 300) || ($(".container-fluid.search-page").scrollTop() + $(".container-fluid.search-page").height() >= $(document).height() - 300)) && (counter - 1) * GlobalSearchAPI.RECORDS_LIMIT <= $scope.hits && !requestLock) {
                    requestLock = true;
                    latestTop = currentTop;

                    GlobalSearchDataManager.getSearchResult(hUser, $scope.searchPhrase, counter++ * GlobalSearchAPI.RECORDS_LIMIT, GlobalSearchAPI.RECORDS_LIMIT).then(function (res) {
                        $scope.results = $scope.results.concat(res.results);
                        $scope.resultsLimit = res.hits;
                        requestLock = false;
                        if ($scope.error) {
                            delete $scope.error;
                        }
                        $scope.$digest()
                    }, function (err) {
                        console.error(err);
                        $scope.results = [];
                        $scope.error = true;
                        $scope.$digest()
                    });

                }


            });
        });

        $scope.detectResultType = function (type) {
            counter = 0;
            $scope.results = [];
            getResults(type);
        };

        $scope.detectResultType();
    }]);
angular.module('harriApp');

